import Vue from 'vue'
import erContent from './erContent.vue'
import  gojs from 'gojs'


Vue.config.productionTip = false
Vue.prototype.go=gojs

new Vue({
  render: h => h(erContent),
}).$mount('#erContent')
